import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconDependencyOutline } from '@saucelabs/ds-icons';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import { MANUAL_TEST_EVENTS, trackEvent } from '../../../tracking';
import {
  constants as installDependentAppConstants,
  FilesModal as InstallDependencyModal,
} from '../../installDependentApp';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const InstallAppButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceDescriptor,
    deviceToolsDisabled,
  } = useSelector(selectors.toolbarButtonSelector);

  const showInstallDependyModal = () => {
    void dispatch(modalActions.showModal(installDependentAppConstants.MODAL_KEY));

    trackEvent(MANUAL_TEST_EVENTS.SHOW_DEPENDENT_APP, {
      deviceName: deviceDescriptor.name,
      os: deviceDescriptor.os,
    });
  };

  return (
    <>
      <InstallDependencyModal />

      <GenericButton
        dataQa="live-session-toolbar-install-app-button"
        disabled={deviceToolsDisabled}
        icon={IconDependencyOutline}
        label="Install App"
        onPress={showInstallDependyModal}
        role={role}
      />
    </>
  );
};

InstallAppButton.displayName = 'InstallAppButton';

export default InstallAppButton;
